"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsAiHubAdmin = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
require("./styles/admin.scss");
var ai_hub_route_utils_1 = require("../shared/utils/ai-hub-route-utils");
var StrategyBuilder_1 = require("../StrategyBuilder/StrategyBuilder");
var Settings_1 = require("../Settings/Settings");
var Platform_1 = require("../Platform/Platform");
var Metrics_1 = require("../Metrics/Metrics");
var Security_1 = require("../Security/Security");
var Extraction_1 = require("../Extraction/Extraction");
var Users_1 = require("../Users/Users");
var use_metrics_rbac_1 = require("../Metrics/hooks/use-metrics-rbac");
var demo_auth_context_1 = require("../shared/auth/demo-auth-context");
var ROLE_LABEL_BY_ROLE = {
    admin: 'Administrator',
    owner: 'Element Owner',
    'group-owner': 'Element Group Owner',
    'regular-user': 'Regular User',
};
/**
 * WsAiHubAdmin - Admin section for AI Hub with sub-tabs for managing
 * Strategy, Platform, Elements (covering metrics, personas, pains,
 * benefits, risks, technologies, data sources, integrations, budget
 * and roadmap items), Security, and AI Hub Settings.
 *
 * @param {WsAiHubAdminProps} props - Component props
 * @returns {JSX.Element} Rendered component
 */
var WsAiHubAdmin = function (props) {
    var _a, _b, _c, _d, _e;
    var activeUser = demo_auth_context_1.useDemoAuth().activeUser;
    var activeRbacRole = use_metrics_rbac_1.useActiveRbacRole();
    var _f = react_1.useState(false), tabsCollapsed = _f[0], setTabsCollapsed = _f[1];
    var email = ((_a = props.currentUser) === null || _a === void 0 ? void 0 : _a.email) || '';
    var urlSubTab = ai_hub_route_utils_1.getAiHubAdminSubTab(((_b = props.location) === null || _b === void 0 ? void 0 : _b.pathname) || '', ((_c = props.location) === null || _c === void 0 ? void 0 : _c.search) || '');
    var _g = react_1.useState(urlSubTab), subTab = _g[0], setSubTab = _g[1];
    // Update subTab state when URL changes
    react_1.useEffect(function () {
        if (props.location) {
            setSubTab(ai_hub_route_utils_1.getAiHubAdminSubTab(props.location.pathname, props.location.search));
        }
    }, [(_d = props.location) === null || _d === void 0 ? void 0 : _d.pathname, (_e = props.location) === null || _e === void 0 ? void 0 : _e.search]);
    // Function to update URL with the canonical admin path
    var updateSubTabInUrl = function (newSubTab) {
        if (props.history && props.location) {
            props.history.push(ai_hub_route_utils_1.buildAiHubAdminSubTabPath(props.location.pathname, props.location.search, newSubTab));
        }
        setSubTab(newSubTab);
    };
    var renderSubTabContent = function (targetSubTab) {
        switch (targetSubTab) {
            case 'strategy-builder':
                return react_1.default.createElement(StrategyBuilder_1.WsAiHubAdminStrategyBuilder, { currentUser: { email: email } });
            case 'platform':
                return react_1.default.createElement(Platform_1.WsAiHubAdminPlatform, null);
            case 'metrics':
                return react_1.default.createElement(Metrics_1.WsAiHubAdminMetrics, null);
            case 'security':
                return react_1.default.createElement(Security_1.WsAiHubAdminSecurity, null);
            case 'settings':
                return react_1.default.createElement(Settings_1.WsAiHubAdminSettings, null);
            case 'extraction':
                return react_1.default.createElement(Extraction_1.WsAiHubAdminExtraction, null);
            case 'users':
                return react_1.default.createElement(Users_1.WsAiHubAdminUsers, null);
            default:
                return react_1.default.createElement(StrategyBuilder_1.WsAiHubAdminStrategyBuilder, { currentUser: { email: email } });
        }
    };
    var adminTabs = [
        {
            key: 'strategy-builder',
            label: 'Strategy Builder',
            iconName: 'Lightbulb',
            status: 'ready',
        },
        {
            key: 'platform',
            label: 'Platform',
            iconName: 'Server',
            status: 'placeholder',
        },
        {
            key: 'metrics',
            label: 'Elements',
            iconName: 'BulletedList',
            status: 'ready',
        },
        {
            key: 'security',
            label: 'Security',
            iconName: 'Shield',
            status: 'placeholder',
        },
        {
            key: 'settings',
            label: 'Data Sources',
            iconName: 'Database',
            status: 'ready',
        },
        {
            key: 'extraction',
            label: 'Extraction',
            iconName: 'AnalyticsReport',
            status: 'ready',
        },
        {
            key: 'users',
            label: 'Users',
            iconName: 'Contact',
            status: 'placeholder',
        }
    ];
    var visibleAdminTabs = react_1.useMemo(function () {
        if (activeRbacRole === 'admin') {
            return adminTabs;
        }
        if (activeRbacRole === 'owner' || activeRbacRole === 'group-owner') {
            return adminTabs.filter(function (tab) { return tab.key === 'metrics'; });
        }
        return [];
    }, [activeRbacRole, adminTabs]);
    var activeSubTab = react_1.useMemo(function () {
        if (visibleAdminTabs.length === 0) {
            return null;
        }
        if (visibleAdminTabs.some(function (tab) { return tab.key === subTab; })) {
            return subTab;
        }
        return visibleAdminTabs[0].key;
    }, [subTab, visibleAdminTabs]);
    var statusBadge = {
        placeholder: {
            label: 'Planned',
            tooltip: 'Planned section — no UI or backend implementation yet.',
            className: 'ws-ai-hub-admin-tab-badge--placeholder',
        },
        'ui-only': {
            label: 'UI only',
            tooltip: 'Interface available, but backend logic is not yet wired up — data shown may be mocked.',
            className: 'ws-ai-hub-admin-tab-badge--ui-only',
        },
        ready: {
            label: 'Ready',
            tooltip: 'Ready for integration — UI and backend wiring are in place.',
            className: 'ws-ai-hub-admin-tab-badge--ready',
        },
    };
    return (react_1.default.createElement("div", { className: "ws-ai-hub-admin " + (tabsCollapsed ? 'is-tabs-collapsed' : '') },
        react_1.default.createElement("div", { className: "ws-ai-hub-admin-tabs " + (tabsCollapsed ? 'is-collapsed' : '') },
            react_1.default.createElement("button", { type: "button", className: "ws-ai-hub-admin-tabs-toggle", "aria-label": tabsCollapsed ? 'Expand admin menu' : 'Collapse admin menu', title: tabsCollapsed ? 'Expand menu' : 'Collapse menu', onClick: function () { return setTabsCollapsed(function (value) { return !value; }); } },
                react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: tabsCollapsed ? 'ChevronRight' : 'ChevronLeft' })),
            react_1.default.createElement("ul", { className: "tabs is-boxed" }, visibleAdminTabs.map(function (tab) {
                // const badge = tab.status ? statusBadge[tab.status] : undefined;
                return (react_1.default.createElement("li", { key: tab.key, className: activeSubTab === tab.key ? 'is-active' : '' },
                    react_1.default.createElement("a", { href: "#!", onClick: function (e) {
                            e.preventDefault();
                            updateSubTabInUrl(tab.key);
                        } },
                        react_1.default.createElement(office_ui_fabric_react_1.Icon, { iconName: tab.iconName, className: "ws-ai-hub-admin-tab-icon" }),
                        tabsCollapsed ? null : react_1.default.createElement("span", null, tab.label))));
            }))),
        react_1.default.createElement("div", { className: "ws-ai-hub-admin-content" }, activeSubTab ? renderSubTabContent(activeSubTab) : null)));
};
exports.WsAiHubAdmin = WsAiHubAdmin;
